<template>
  <div class="payment-first-border">
    <div class="payment-first-background"></div>
    <!-- 该div上左上角图标 -->
    <!-- 标题，内容，按钮整体div -->
    <div class="payment-first-content-parent">
      <router-link class="payment-first-shopvidi-logo" :to="{path:'/'}"><img src="https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png" height="40px" width="160px"/></router-link>
      <div class="payment-first-title">Grow your business with net 60 terms</div>
      <div class="payment-first-content">Order more inventory by increasing your net 60 terms limit!</div>
      <template v-if="flag === '' || flag === 'declined'">
        <!-- <div class="payment-first-button-border" @click="openFirst"><el-button class="payment-first-button">Apply Now</el-button></div> -->
        <!-- <div class="payment-first-button-border" @click="newApplyPC" v-if="login"><el-button class="payment-first-button">Apply Now</el-button></div> -->
      </template>
      <div class="payment-first-banlance-1">
        <!-- <img src="../../assets/banlance-1-1x.png"/> -->
        <img src="@/assets/20240104-163100.png"/>
      </div>
      <div class="payment-first-banlance-2">
        <!-- <img src="../../assets/banlance-2-1x.png"/> -->
        <img src="@/assets/20240104-163236.png"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    flag: ''
  },
  data() {
    return {

    }
  },
  created() {
    // 增加查询PC信息
  },
  methods: {
    openFirst() {
      this.$emit('openFirst', 'second')
    },
    // TODO haoyuanw add 2021-11-05 pc 提示框
    newApplyPC() {
      // 弹出提示框
      this.$emit('newApplyPC')
    }
  }
}
</script>

<style lang="less" scoped>
/* 第一部分外边框 */
.payment-first-border{width:100vw;height: 580px;position: relative;}
/* 第一部分的logo */
/* 第一部分标题，内容，按钮整体div */
.payment-first-content-parent{position: relative;top:-550px;max-width:1400px;z-index: 9;margin: 0 auto;width: auto;}
.payment-first-title{font-size: 58px;font-family: STIXGeneral;font-weight: 400;line-height: 73px;color: #262B2F;opacity: 1;text-align: center;}
.payment-first-content{font-size: 21px;font-family: Graphik;font-weight: 500;line-height: 28px;color: #262B2F;opacity: 1;width:45%;margin:0 auto;margin-top:20px;text-align: center;}
.payment-first-button-border{text-align: center;}
.payment-first-button{font-size: 21px;font-family: Graphik;font-weight: 500;line-height: 20px;color: #262B2F;opacity: 1;width:15%;margin-top:50px;}
.payment-first-banlance-1{text-align: right;width: 95%;margin-top: 0px;}
.payment-first-banlance-2{text-align: left;width: 90%;margin: 0 auto;margin-top: 80px;}
/* 第一部分的背景图 */
.payment-first-background{background: url('../../assets/payment-1x.png');background-size: cover;background-position: center;height: 580px;width: 100vw;position: relative;}
/deep/ .el-button--default:focus, .el-button--default:active, .el-button--default:hover{background-color:#FFFFFF !important;color: #262B2F !important;border-color:#FFFFFF !important}
@media screen and (max-width: 600px){
  .payment-first-title{font-size: 36px;width:80%;margin:0 auto;line-height: 43px;margin-top: 20px;}
  .payment-first-content{width: 90%;font-size: 16px;}
  .payment-first-banlance-1{margin-top:0;width: 45%;margin:20px auto}
  .payment-first-banlance-2{display: none;}
  .payment-first-button{width: 50%;}
}
</style>



// WEBPACK FOOTER //
// src/pages/credit-payment/payment-first.vue